<template>
    <div class="te-credit-payment-methods">
        <div class="te-cart-heading">{{languageSettings.creditPayment}}</div>
        <ul class="te-credit-payment-methods-list">
            <li v-for="(requiredPayment, i) in value"
                :key="i"
            >
                <div class="te-credit-payment">
                    <span>{{languageSettings.accountTokenLabel}}</span>&nbsp;<strong>{{formatPrice(requiredPayment.currency, requiredPayment.amount)}}</strong>
                    <input class="te-form-control" type="text" name="account-token" :value="requiredPayment.token" :placeholder="languageSettings.accountTokenPlaceholder" @input="onSetToken($event.target.value, i)">
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import format from '../services/format'

    export default {
        name: "CreditPaymentMethod",

        // data() {
        //     return {
        //         method: null,
        //     };
        // },

        props: {
            value: {
                type: Array
            },
            language: {
                type: Object
            },
        },

        computed: {
            ...mapGetters({
                order: 'order',
            }),

            languageSettings: function() {
                const defaultSettings = {
                    creditPayment: 'Payment',
                    // creditPaymentDescription: 'Enter your account token.',
                    accountTokenLabel: 'Enter your account for payment of',
                    accountTokenPlaceholder: 'Enter your account.',
                };
                return Object.assign(defaultSettings, this.language);
            },

            // customCurrencyPayments: function() {
            //     return this.order.requiredPayments.filter(rp => rp.currency.code.length > 3)
            // },

        },

        methods: {
            formatPrice(currency, amount) {
                return format.price(currency, amount);
            },

            onSetToken(token, requiredPaymentIndex) {
                // this.method = method;
                // this.$emit('change', this.method);

                const rp = this.value.map((x) => x);
                rp[requiredPaymentIndex].token = token;
                this.$emit('input', rp)
            },
        }
    }
</script>

<style scoped>

</style>